export default __webpack_public_path__ + "static/media/Pistol_9.23697ba1.png";